module.exports = __webpack_public_path__ + "img/icon-legal-hammer.a567bb68.svg";